import functionsDataResumen from './functionsDataResumen';

const affecteds = (state, data) => {
  //////////////////////////////////////////Lista de Damnificados-Denunciantes-Para-caratula////////////////////////////////
  ///////////Esta lista tiene en consideracion que En sumario por oficio puede o no haber un damnificado/////////////
  try{
    let ListaDenunciantes='';
    let ListaDenunciantesDatosParciales='';
    let damnificado = '';
    let damnificadoDatosParciales = '';
    for(const item of state?.denunciante?.list) //aca solo va a ser un denunciante(pero tomamos en cuenta el hecho de que pueda ser mas de uno)
    {
      if(item.type != 'empty')
      {
        if( item.doc != undefined)
        {
          if(item.ordenPublico == true)
          {
            damnificado = "<b>Orden Publico</b>"
            damnificadoDatosParciales = "<b>Orden Publico</b>"

          }else
          {
            damnificadoDatosParciales = item.RolesdenunciaID  != undefined ? '<b>'+item.RolesdenunciaID +'</b>': damnificadoDatosParciales
            damnificadoDatosParciales = item.doc.apellido != undefined ?  damnificadoDatosParciales+' <b>'+item.doc.apellido+'</b>': damnificadoDatosParciales
            damnificadoDatosParciales = item.doc.nombre != undefined ?  damnificadoDatosParciales+'<b>, ' +item.doc.nombre+'</b>' : damnificadoDatosParciales; 
            damnificadoDatosParciales = item.doc.documento != undefined ? damnificadoDatosParciales+'<b>, DNI N° '+ item.doc.documento+'</b>': damnificadoDatosParciales;

            damnificado = item.RolesdenunciaID  != undefined ? '<b>'+item.RolesdenunciaID +'</b>': damnificado
            damnificado = item.doc.apellido != undefined ? damnificado+' <b>'+item.doc.apellido+'</b>': damnificado
            damnificado = item.doc.nombre != undefined ?  damnificado+'<b>, ' +item.doc.nombre+'</b>' : damnificado; 
            damnificado = item.doc.documento != undefined ? damnificado+'<b>, DNI N° '+ item.doc.documento+'</b>': damnificado;
            damnificado = item.doc.nacionalidad != undefined ? damnificado+ ', de nacionalidad '+item.doc.nacionalidad.nombre : damnificado;
            damnificado = item.doc.estadoCivil != undefined ? damnificado+ ', estado civil '+item.doc.estadoCivil.nombre: damnificado;
            damnificado = item.doc.fechaNacimiento != undefined ? damnificado+', de '+functionsDataResumen.calculateAge(item.doc.fechaNacimiento)+' años de edad' : damnificado;
            damnificado = item.doc.instruccion != undefined ? damnificado+', '+item.doc.instruccion.nombre : damnificado;
            damnificado = item.doc.profesion != undefined ? damnificado+', de profesion '+item.doc.profesion : damnificado;
  
            let dom =  item.doc.domicilio != undefined && item.doc.domicilio != null && item.doc.domicilio != ''? item.doc.domicilio  : ""
            let domSIPE = item.doc.domicilioSIPE != undefined && item.doc.domicilioSIPE != null && item.doc.domicilioSIPE != ''? item.doc.domicilioSIPE : ""
    
            let domicilio = dom != "" ? dom: domSIPE;
            damnificado= domicilio != "" ? damnificado+', con domicilio en '+domicilio+' \n ': damnificado;
          }

        }else
          damnificadoDatosParciales = item?.RolesdenunciaID  != undefined ? '<b>'+item?.RolesdenunciaID +'</b>': damnificadoDatosParciales
          damnificadoDatosParciales = item.Apellido != undefined ? damnificadoDatosParciales+' <b>'+item.Apellido+'</b>': damnificadoDatosParciales
          damnificadoDatosParciales = item.Nombre != undefined ?  damnificadoDatosParciales+'<b>, ' +item.Nombre+'</b>' : damnificadoDatosParciales; 
          damnificadoDatosParciales = item.Dni != undefined && item.Dni != '---'? damnificadoDatosParciales+'<b>, DNI N° '+ item.Dni +'</b>': damnificadoDatosParciales;{

          damnificado = item?.RolesdenunciaID  != undefined ? '<b>'+item?.RolesdenunciaID +'</b>': damnificado
          damnificado = item.Apellido != undefined ? damnificado+ ' <b>'+item.Apellido+'</b>': damnificado
          damnificado = item.Nombre != undefined ?  damnificado+'<b>, ' +item.Nombre+'</b>' : damnificado; 
          damnificado = item.Dni != undefined && item.Dni != '---'? damnificado+'<b>, DNI N° '+ item.Dni +'</b>': damnificado;
          damnificado = item.Nacionalidad != undefined ? damnificado+ ', de nacionalidad '+item.Nacionalidad : damnificado;
          damnificado = item.EstadoCivil != undefined ? damnificado+ ', estado civil '+item.EstadoCivil: damnificado;
          damnificado = item.FechaDeNacimiento != undefined ? damnificado+', de '+functionsDataResumen.calculateAge(item.FechaDeNacimiento)+' años de edad' : damnificado;
          damnificado = item.Instruccion != undefined ? damnificado+', '+item.Instruccion : damnificado;
          damnificado = item.Profesion != undefined ? damnificado+', de profesion '+item.Profesion : damnificado;
          damnificado = item.DomicilioSipe != undefined && item.DomicilioSipe != '' && item.DomicilioSipe != null ? damnificado+', con domicilio en '+item.DomicilioSipe+' \n ': damnificado;
        }

        if(ListaDenunciantes=='')
        {
          ListaDenunciantes=damnificado;
          ListaDenunciantesDatosParciales = damnificadoDatosParciales
        }else{
          ListaDenunciantes=damnificado;
          ListaDenunciantesDatosParciales = ListaDenunciantesDatosParciales+'; '+damnificadoDatosParciales
        }
      }
    }
    //con las siguientes  7 lineas de codigo nos ahorramos tener que repetir todo el proceso anterior para tener el mismo string sin "<b>" y "</b>"
    if(!ListaDenunciantes)
    {
      data.denunciantes = " ANONIMO " ;
      data.denuncianteDatosParciles = " ANONIMO ";
      data.denunciantesCaratula = " ANONIMO ";
    }else
    {
      data.denunciantesCaratula = ListaDenunciantes;
      data.denunciantes = ListaDenunciantes.replace(/<\/b>|<b>/g, '');
      data.denuncianteDatosParciles = ListaDenunciantesDatosParciales.replace(/<\/b>|<b>/g, '');
    }
  }catch(e)
  {
    console.log('tiro un problema al cargar el Denunciante: '+ e);
  }
  ///////////////////////////////////Lista de Dni////////////////////////////////////
  try{
    var ListaDenunciantesDni = '';
    for(const item of state?.denunciante?.list)
    {
      if(item.type != 'empty')
      {
        if( item.doc != undefined)
        {
          // ListaDenunciantesDni = item.doc.documento != undefined ? ListaDenunciantesDni+'; '+ item.doc.documento: ListaDenunciantesDni;
          ListaDenunciantesDni = ListaDenunciantesDni != '' ? ListaDenunciantesDni+'; '+ item.doc.documento: item.doc.documento;
        }else
        {
          // ListaDenunciantesDni = item.Dni != undefined ? ListaDenunciantesDni+'; '+ item.Dni: ListaDenunciantesDni;
          ListaDenunciantesDni = ListaDenunciantesDni != '' ? ListaDenunciantesDni+'; '+ item.Dni: item.Dni;
        }
      }
      data.denunciantesDni = ListaDenunciantesDni;
    }
    // console.log("data.denunciantesDni: ",data.denunciantesDni)
  }
  catch(e){
    console.log('tiro un problema al cargar el DenunciantesNyA: '+ e);
  }
  /* La siguiente linea de codigo se realizo con la implementacion de Preliminares, en estas no siempre hay un Protagonista, haciendo que denunciante.list[0] no siempre exista */
  let Protagonista = state?.denunciante?.list?.length > 0 ? state?.denunciante?.list?.[0] : state?.denunciante?.list
  //contamos cantidad de denunciantes
  let TotalDenunciantes = state.denunciante.list.length - 1;
  try {
    //contamos cantidad de denunciantes sin dni y que no sean ordenPublico
    let persSinDni = state.denunciante.list.filter(e => (e?.doc?.documento == undefined || e?.doc?.documento == '') && (e?.ordenPublico == undefined || e?.ordenPublico == false )).length - 1;
    if(persSinDni === 0 && Protagonista?.doc?.documento === undefined && Protagonista.Dni !== undefined){
      data.dniDenunciante = state?.denunciante.list?.length != 0 ? Protagonista.Dni : "";
    } else {
      data.dniDenunciante = Protagonista?.doc?.documento != undefined ? Protagonista?.doc?.documento : "";
    }
  }
  catch(e){
    console.log('error', e);
  }
 
  try {
    data.instruccion = Protagonista?.doc?.instruccion?.nombre; 
  }
  catch(e){    
    console.log('error', e);
  }
 
  try {
    data.profesion = Protagonista.Profesion;
    if (Protagonista?.doc?.profesion) {
      data.profesion =", de profesión " + Protagonista?.doc?.profesion;
    }
  }
  catch(e){    
    console.log('error', e);
  }  
 
  try {
    data.telefonoDenunciante = state.denunciante.list?.length != 0 ? Protagonista.Telefono : "";
  }
  catch(e){
    console.log('error', e);
  }
 
  try {
    data.apellidoDenunciante = state.denunciante.list?.length != 0 ? Protagonista.Apellido: "";
  }
  catch(e){
    console.log('error', e);
  }

  try {
    data.nombreDenunciante = state.denunciante.list?.length != 0 ? Protagonista.Nombre : "";  
  }
  catch(e){
    console.log('error', e);
  }  
 
  try {
    data.nacionalidadDenunciante = Protagonista?.doc?.nacionalidad?.nombre;
  }
  catch(e){
    console.log("fallo al cargar la nacionalidad del Denunciante", e)
  }
 
  try {
    data.estadoCivilDenunciante = state.denunciante.list?.length != 0 ?  Protagonista.EstadoCivil: "";
  }
  catch(e){
    console.log('error', e);
  }
   
  try {
    data.edadDenunciante = functionsDataResumen.calculateAge(Protagonista.FechaDeNacimiento);
  }
  catch(e){
    console.log('error', e);
  }

  try {
    if(Protagonista?.doc?.domicilio === undefined && Protagonista.DomicilioSipe !== undefined){
      if(state.denunciante.list?.length !== 0)  {
        data.lugarDeRecidenciaDenunciante = Protagonista.DomicilioSipe != undefined ?  Protagonista.DomicilioSipe: "";
      }
    } else{
      let dom =  Protagonista?.doc?.domicilio != undefined ? Protagonista?.doc?.domicilio  : ""
      let domSIPE = Protagonista?.doc?.domicilioSIPE != undefined ? Protagonista?.doc?.domicilioSIPE : ""
  
      data.lugarDeRecidenciaDenunciante = dom != "" ? dom: domSIPE;
    }
  }
  catch(e){
    console.log('error', e);
  } 
}
export default {
  affecteds
}